import classNames from "classnames";
import { Button } from "@components/Button";
import FanstaDialog from "@components/FanstaDialog";
import { launchTel } from "@libs/utils/url";
import styles from "./index.module.css";
import type { FC } from "react";

type Props = {
  isShown: boolean;
  tel: string;
  onClose: () => void;
};

export const ReservationTelModal: FC<Props> = ({ isShown, tel, onClose }) => {
  return (
    <FanstaDialog isShown={isShown} onBackgroundClick={onClose}>
      <div className={styles.modal}>
        <div className={styles.title}>電話なら予約できることがあります</div>
        <p className={styles.message}>{tel}へ電話をかけますか？</p>
        <div className={styles.buttonBlock}>
          <Button
            className={classNames(styles.btn, styles.cancelBtn)}
            styleType="outlined"
            colorType="primary"
            type="button"
            onClick={onClose}
          >
            キャンセル
          </Button>
          <Button
            className={classNames(styles.btn, styles.telBtn)}
            styleType="filled"
            colorType="primary"
            onClick={() => launchTel(tel, "電話をかける")}
          >
            電話をかける
          </Button>
        </div>
        <p className={styles.message}>Fanstaを見たとお伝えください。</p>
      </div>
    </FanstaDialog>
  );
};
